import React, { useEffect } from 'react'
import Membership from '../../../Components/Membership';
import MembershipForm from '../../../Components/MemberShipForm';
import ApplicationReview from '../../../Components/ApplicationReview';
import Checkout from './Checkout';
import PaymentSuccess from '../../../Components/PaymentSuccess';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails } from '../../../api/common';
import { setProcessData } from '../../../redux/actions/processAction';
import { useLocation, useParams } from 'react-router-dom';
import { setUserData } from '../../../redux/actions/authActions';

export default function UpgradeMembership() {
  const dispatch = useDispatch();
  const { step } = useParams();
  const { user } = useSelector((state) => state.auth);
  const {pathname} = useLocation();

  const getUserData = async () => {
    try {
      const res = await getUserDetails(user?.id);
      if (res.status === 200) {
        const respData = res.data.data;
        dispatch(setProcessData({
          ...respData,
          email_verified: true,
          mobile_verified: true
        }));
        if(pathname.includes("upgrade")){
          dispatch(setUserData(respData));
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if(user?.id){
      getUserData();
    }
  }, []) // eslint-disable-line

  const renderStepComp = () => {

    switch (step) {
      case "select-membership":
        return <Membership />;
      case "membership-form":
        return <MembershipForm />;
      case "application-review":
        return <ApplicationReview />;
      case "checkout":
        return <Checkout />;
      case "payment-success":
        return <PaymentSuccess />;
      default:
        return <Membership />;
    }
  };

  return <>{renderStepComp()}</>;

}
